<template>
  <v-dialog
    v-model="dialog"
    :max-width="showFilerList ? 600 : 350"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    v-bind="$vuetify.breakpoint.xsOnly ? { transition: 'dialog-bottom-transition' } : {}"
    persistent
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :disabled="!user || !user.id || !filerGroup || !filerGroup.filers.length"
        :small="$vuetify.breakpoint.xsOnly"
        color="primary"
        class="ma-0"
        v-on="on"
      >
        {{ btnText }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <v-toolbar-title>
          {{ !filerGroup || !filerGroup.id ? 'Create group' : 'Update group' }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          class="ma-0"
          @click="closeDialog()"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="validForm"
          lazy-validation
          @submit.prevent="createGroup()"
        >
          <v-text-field
            ref="groupNameField"
            v-model="groupName"
            :rules="groupNameRules"
            clearable
            label="Group name"
            @keyup.enter="createGroup()"
            @keyup.esc="closeDialog()"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="px-4">
        <v-spacer />
        <v-btn
          :loading="saving"
          :disabled="saving || !validForm"
          depressed
          color="primary"
          @click="createGroup()"
        >
          Submit
        </v-btn>
      </v-card-actions>
      <v-card-text v-if="showFilerList">
        <helpers-section-sub-header class="mb-2">
          The new group will have the following members <span class="grey--text">({{ filerGroup.filers.length }})</span>:
        </helpers-section-sub-header>
        <v-chip
          v-for="filer in filerGroup.filers"
          :key="filer.id"
          small
          label
          color="primary white--text"
        >
          {{ filer.name }}
        </v-chip>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// Modules
import api from '@/store/api'
import { mapState } from 'vuex'

export default {
  props: {
    filerGroup: {
      type: Object,
      required: true
    },
    local: Boolean,
    showFilerList: Boolean
  },

  data () {
    return {
      dialog: false,
      saving: false,
      validForm: false,
      groupName: null,
      groupNameRules: [
        v => !!v || 'Group name is required',
        v => (v && v.length >= 2) || 'Group name must be at least 2 characters'
      ]
    }
  },

  computed: {
    ...mapState({
      user: state => state.user.user,
      groups: state => state.user.groups
    }),

    btnText () {
      if (!this.user || !this.user.id) return 'Log in to save'
      else if (!this.filerGroup || !this.filerGroup.id) return 'Create group'
      else return 'Update group'
    }
  },

  watch: {
    dialog (isVisible) {
      if (isVisible) {
        this.groupName = this.filerGroup.description
        this.$nextTick(() => this.$refs.groupNameField.focus())
      }
    }
  },

  methods: {
    createGroup () {
      if (this.$refs.form.validate()) {
        const group = {
          ...this.filerGroup,
          description: this.groupName
        }
        let url = 'groups'

        if (group.id) url += `/${group.id}.json`

        this.saving = true

        api.post(url, group)
          .then(response => {
            this.$store.dispatch('user/loadGroups').then(() => {
              const foundGroup = this.groups.find(g => g.id === response.data.id)

              if (this.local) {
                this.$emit('update:filerGroup', foundGroup)
              } else {
                this.$store.commit('app/SET_SELECTED_GROUP', foundGroup)
              }
            })
            this.$store.commit('app/NOTIFICATION', {
              type: 'success',
              text: `Saved group ${group.description}, consisting of ${group.filers.length} funds.`
            })
            this.closeDialog()
          })
          .catch(error => {
            this.$store.commit('app/NOTIFICATION', {
              type: 'error',
              text: (error.response && error.response.data) || error.message
            })
          })
          .then(() => (this.saving = false))
      }
    },

    closeDialog () {
      this.dialog = false
      this.$refs.form.reset()
    }
  }
}
</script>
